import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=1bfb2cce&scoped=true"
import script from "./CampaignEdit.vue?vue&type=script&lang=js"
export * from "./CampaignEdit.vue?vue&type=script&lang=js"
import style0 from "./CampaignEdit.vue?vue&type=style&index=0&id=1bfb2cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb2cce",
  null
  
)

export default component.exports